import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import {
    ToastComponent,
    ToastModel,
    ToastModule,
} from '@syncfusion/ej2-angular-notifications';

@Component({
    selector: 'app-toast-runtime-host',
    standalone: true,
    imports: [CommonModule, ToastModule],
    templateUrl: './toast-runtime-host.component.html',
    styleUrls: ['./toast-runtime-host.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastRuntimeHostComponent implements AfterViewInit {
    @ViewChild('toastRef') private toastRef?: ToastComponent;

    readonly position = { X: 'Right', Y: 'Bottom' };
    readonly defaultTimeout = 8000;

    private isInitialized = false;
    private pendingModels: ToastModel[] = [];

    ngAfterViewInit(): void {
        // O toast será marcado como inicializado quando o evento created for disparado
    }

    onToastCreated(): void {
        this.isInitialized = true;
        this.processPendingModels();
    }

    show(model: ToastModel): void {
        if (!this.isInitialized) {
            this.pendingModels.push(model);
            return;
        }

        this.displayToast(model);
    }

    hideAll(): void {
        if (this.toastRef) {
            this.toastRef.hide('All');
        }
    }

    private displayToast(model: ToastModel): void {
        const toast = this.toastRef;
        if (!toast) {
            return;
        }

        const normalizedModel: ToastModel = {
            showCloseButton: true,
            showProgressBar: true,
            timeOut: this.defaultTimeout,
            extendedTimeout: 1200,
            ...model,
        };

        toast.show(normalizedModel);
    }

    private processPendingModels(): void {
        while (this.pendingModels.length > 0) {
            const model = this.pendingModels.shift();
            if (model) {
                this.displayToast(model);
            }
        }
    }
}